import { ApplyModule } from './apply/apply.module';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import {MatSelectModule} from '@angular/material/select';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DialogModule} from 'primeng/dialog';
import { RegisterComponent } from './auth/register/register.component';
import { changePasswordComponent } from './auth/changePassword/changePassword.component';
import { OtpComponent } from './auth/register/otp.component';
import { RegisteredComponent } from './auth/register/registered.component';
import { TermsComponent } from './auth/register/terms.component';
import { ForgotPasswordComponent } from './auth/Forgot-password/forgot-password.component';
import { resetPasswordComponent } from './auth/Reset-password/reset-password.component';
import { ResendEmailComponent } from './auth/Forgot-password/resend-email.component';
import { ConfirmPassComponent } from './auth/register/confirmPass.component';
import { config } from '../../config';
import { OTPModule } from './auth/otp/otp.module';
import { AuthGuardService } from './shared/auth-guard.service';
import { RoleGuardService } from './shared/role-guard.service';
import { ApiService } from './shared/api.service';
import { ApplyTokenInterceptor } from './shared/apply-token.interceptor';
import { NB_AUTH_TOKEN_INTERCEPTOR_FILTER, NbAuthJWTInterceptor } from '@nebular/auth';
import { NavmenuComponent } from './navmenu/navmenu.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule, MatButtonModule, MatSidenavModule, MatIconModule, MatListModule, MatCardModule, MatExpansionModule } from '@angular/material';
import { ApplyComponent } from './apply/apply.component';
import { AdminOtpComponent } from './pages/admin-dashboard/admin-otp/admin-otp.component';
import {StatementComponent} from './pages/errata/statement.component'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
//NEW

import { MatStepperModule, MatInputModule, MatAutocompleteModule,MatIconRegistry } from '@angular/material';
import {MatRadioModule} from '@angular/material/radio';
import { InternationalPhoneModule } from 'ng4-intl-phone';
import {NgxPaginationModule} from 'ngx-pagination';
import { FeedbackComponent } from './pages/payment-success/feedback.component';
import { GetPasswordComponent } from './auth/get-password/get-password.component';

import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { DomSanitizer } from '@angular/platform-browser';
import {OnboardingButtonsPosition, OnboardingModule, OnboardingService} from '@rosen-group/ngx-onboarding';
import { RouterModule } from '@angular/router';
import { HelpComponent } from './help/help.component';
import { AdminComponent } from './admin/admin.component';
import { AdminloginComponent } from './admin/adminlogin/adminlogin.component';
import { PaymentSuccessModule } from './payment-success/payment-success.module';
import { FirstFailureModule } from './payment-success/FirstFailure.module';
import { FirstCancelModule } from './payment-success/FirstCancel.module';
import { FeedbackNewComponent } from './payment-success/feedback.component';
import { PaymentModelComponent } from './payment-success/payment.component';
import { ConfirmationDialogService } from './pages/admin-dashboard/confirmation-dialog/confirmation-dialog.service';
import { ConfirmationDialogComponent } from './pages/admin-dashboard/confirmation-dialog/confirmation-dialog.component';
import { LandingComponent } from './@theme/components/landingPage/landing.component';
//const socketconfig: SocketIoConfig = { url: 'http://etranscript.in', options: {reconnection: true,transports: ['websocket'],secure: true} };
//const socketconfig: SocketIoConfig = { url: 'https://mu.etranscript.in', options: {reconnection: true,transports: ['websocket'],secure: true} };


@NgModule({
  declarations: [AppComponent,
    RegisterComponent,
    changePasswordComponent,
    OtpComponent,
    RegisteredComponent,
    TermsComponent,
    ForgotPasswordComponent,
    resetPasswordComponent,
    ResendEmailComponent,
    ConfirmPassComponent,
    NavmenuComponent,
   // ApplyComponent,
    AdminOtpComponent,
    StatementComponent,
    FeedbackComponent,
    FeedbackNewComponent,
    GetPasswordComponent,
    HelpComponent,
    AdminComponent,
    AdminloginComponent,
    ConfirmationDialogComponent,
    PaymentModelComponent,
    LandingComponent
    ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    OTPModule,
    MatSelectModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    ConfirmDialogModule,
    DialogModule,
    LayoutModule,
   MatToolbarModule,
   MatButtonModule,
   MatSidenavModule,
   MatIconModule,
   MatListModule,
   MatCardModule,
   MatExpansionModule,
   MatStepperModule,
   MatInputModule,
   MatAutocompleteModule,
   MatRadioModule,
   InternationalPhoneModule,
  // SocketIoModule.forRoot(socketconfig),
   OnboardingModule,
   ApplyModule,
   PaymentSuccessModule,
   FirstFailureModule,
   FirstCancelModule,
   RouterModule,
   NgxMatSelectSearchModule
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: HTTP_INTERCEPTORS, useClass: NbAuthJWTInterceptor, multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: ApplyTokenInterceptor, multi: true},
    { provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: filterInterceptorRequest },
    AuthGuardService,
    RoleGuardService,
    ApiService,
    ConfirmationDialogService
 
  ],entryComponents:[
    OtpComponent,
    RegisteredComponent,
    TermsComponent,
    ResendEmailComponent,
    ConfirmPassComponent,
    AdminOtpComponent,
    StatementComponent,
    FeedbackComponent,
    FeedbackNewComponent,
    ConfirmationDialogComponent,
    PaymentModelComponent,
  ]
})
export class AppModule {
  constructor(onboardingService: OnboardingService, sanitizer: DomSanitizer, iconRegistry: MatIconRegistry){
		iconRegistry.addSvgIcon('onboarding_icon',
			sanitizer.bypassSecurityTrustResourceUrl('./assets/icons/onboarding_icon.svg'));
		onboardingService.configure({
			buttonsConfiguration: {
				position: OnboardingButtonsPosition.BottomRight,
				verticalDistanceToBorderInPx: 10,
				horizontalDistanceToBorderInPx: 10
			},
			textConfiguration: {
				regularFontFamily: 'Helvetica, Arial, sans-serif;',
				scriptFontFamily: '"Comic Sans MS", Georgia,  Times New Roman, serif;'
			},
			iconConfiguration: {
				svgIcon: 'onboarding_icon'
			}
		});
	}
}
export function filterInterceptorRequest(req: HttpRequest<any>) {
  return [config.serverUrl+'/api/auth/',
         ]
    .some(url => req.url.includes(url));
}